<template>
    <div>

        <vue-headful title="Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`${backRoute}`">
                        {{ backLabel }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    <template v-if="!id">New Email Alert</template>
                    <template v-else>
                        <template v-if="!loading">Edit {{ alert.alert_name }}</template>
                    </template>
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-4 col-12">
                    <div class="card">
                        <div class="card-header">Alert Details</div>
                        <div class="card-body">
                            <div class="form-group">
                                <div :class="{'control-label': true, 'text-danger': errors.alert_name ,'text-muted': !errors.alert_name}">Alert Name:</div>
                                <div class="">
                                    <input type="text" name="alert_name" v-model="alert.alert_name" :class="{'form-control': true, 'is-invalid': errors.alert_name}" placeholder="Enter Alert Name" />

                                    <span v-if="errors.alert_name" class="text-danger">
                                        <span v-for="error in errors.alert_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="control-label text-muted">Active:</div>
                                <div class="">
                                    <b-form-checkbox v-model="alert.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="control-label text-muted">Alert Description:</div>
                                <div class="">
                                    <textarea class="form-control" placeholder="Enter Alert Description (Optional)" v-model="alert.description" rows="4">{{ alert.description }}</textarea>
                                </div>
                            </div>

                            <div class="form-group" v-if="assetType === 'SubPreQual'">
                                <div class="control-label text-muted">Alert Message: <br/><small class="text-info">This is a custom message that will be included in the Email Alert.</small></div>
                                <div class="">
                                    <textarea class="form-control" placeholder="Enter Alert Message (Optional)" v-model="alert.alert_message" rows="4">{{ alert.alert_message }}</textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            Conditions
                            <button class="btn btn-sm btn-info" type="button" v-on:click="conditions.push({email_field_id: null, logic: null, cond_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <ol style="padding-left: 0;">
                                <li v-for="(cond, i) in conditions" class="mb-2">
                                    <a href="javascript:void(0)" class="text-danger btn-link" v-on:click="deleteCondition(i);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="cond.email_field_id" :options="fieldOptions" />

                                    <b-form-select class="form-control" v-model="cond.logic" :options="logicOptions" style="max-width: 120px;" />

                                    <template v-if="cond.email_field_id && fields[cond.email_field_id].field_type && fields[cond.email_field_id].field_type == 'boolean'">
                                        <select class="form-control" v-model="cond.cond_value">
                                            <option :value="null">-- Select Yes or No --</option>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                    </template>
                                    <template v-if="cond.email_field_id && fields[cond.email_field_id].field_type && fields[cond.email_field_id].field_type == 'date'">

                                    </template>
                                    <template v-if="cond.email_field_id && fields[cond.email_field_id].field_type && fields[cond.email_field_id].field_type == 'dropdown'">
                                        <template v-if="cond.logic == 'DEACTIVATED' || cond.logic == 'DEACTIVATED'">
                                            <multiselect v-model="cond.cond_value.split(',')" placeholder="Select Values" :options="fields[cond.email_field_id].options" :multiple="true" :taggable="true"></multiselect>
                                        </template>
                                        <template v-else>
                                            <select class="form-control"
                                                v-model="cond.cond_value_formatted"
                                                :multiple="(cond.logic == 'Is Any' || cond.logic == 'Is Not Any' ? true : false)">
                                                <option :value="null">-- Select {{ fields[cond.email_field_id].field_label }}--</option>
                                                <template v-for="(opt, j) in fields[cond.email_field_id].options">
                                                    <option :value="opt.id">{{ opt.label }}</option>
                                                </template>
                                            </select>
                                        </template>

                                    </template>
                                    <template v-if="cond.email_field_id && fields[cond.email_field_id].field_type && fields[cond.email_field_id].field_type == 'enum'">
                                        <select class="form-control" v-model="cond.cond_value_formatted">
                                            <option :value="null">-- Select {{ fields[cond.email_field_id].field_label }}--</option>
                                            <template v-for="(opt, j) in fields[cond.email_field_id].options">
                                                <option :value="j">{{ opt }}</option>
                                            </template>
                                        </select>
                                    </template>
                                    <template v-if="cond.email_field_id && fields[cond.email_field_id].field_type
                                                    && (fields[cond.email_field_id].field_type == 'text' ||
                                                        fields[cond.email_field_id].field_type == 'int' ||
                                                        fields[cond.email_field_id].field_type == 'decimal')">
                                        <input type="text" class="form-control" v-model="cond.cond_value" placeholder="Enter Value" />
                                    </template>

                                    <span v-if="errors['conditions['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['conditions['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="Object.keys(custom_fields).length > 0">
                        <div class="card-header">
                            Custom Field Conditions
                            <button class="btn btn-sm btn-info" type="button" v-on:click="custom_field_conditions.push({custom_field_id: null, custom_field_logic: null, custom_field_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <ol style="padding-left: 0;">
                                <li v-for="(cond, i) in custom_field_conditions" class="mb-2">
                                    <a href="javascript:void(0)" class="text-danger btn-link" v-on:click="deleteCustomFieldCondition(i);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="cond.custom_field_id" :options="customFieldOptions" />

                                    <b-form-select class="form-control" v-model="cond.custom_field_logic" :options="customFieldLogic(cond.custom_field_id)" style="max-width: 120px;" />

                                    <template v-if="cond.custom_field_id && custom_fields[cond.custom_field_id].type == 'Date' && (cond.custom_field_logic == 'days_before' || cond.custom_field_logic == 'days_after')">
                                        <input type="text" class="form-control" v-model="cond.custom_field_value" placeholder="Enter Number of Days" />
                                    </template>

                                    <template v-if="cond.custom_field_id && yesNoTypes.indexOf(custom_fields[cond.custom_field_id].type) !== -1">
                                        <b-form-select class="form-control" v-model="cond.custom_field_value" :options="customFieldValueOptions(cond.custom_field_id)" />
                                    </template>

                                    <span v-if="errors['custom_field_conditions['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['custom_field_conditions['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            Recipients
                            <button class="btn btn-sm btn-info" type="button" v-on:click="recipients.push({target_type: null, target_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <strong>Send Email To:</strong>
                            <ol>
                                <li v-for="(recip, i) in recipients" :key="recip.id" class="mb-2">
                                    <a href="javascript:void(0)" class="text-danger btn-link" v-on:click="deleteRecipient(recip.id);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="recip.target_type" :options="recipientOptions" />

                                    <span v-if="recip.target_type != 'Supervisor' && recip.target_type != 'Violator' && recip.target_type != 'Subcontractor'">=</span>

                                    <span v-if="recip.target_type == 'Employee'" class="d-lg-inline-block" style="width: 400px;">
                                        <employee-select
                                            :selectedValues="renderEmployee(recip)"
                                            @vselected="function(employee){ recip.target_value = employee.EmployeeId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false"
                                            :filters="{is_active: 1}" />
                                    </span>

                                    <template v-if="recip.target_type == 'Employee Title'">
                                        <!-- <input type="text" v-model="recip.target_value" placeholder="Enter an Employee Title/Position" class="form-control" /> -->
                                        <b-form-select v-model="recip.target_value" :options="titleOptions" :class="{'is-invalid': errors['recipients['+i+']']}" />
                                    </template>

                                    <template v-if="recip.target_type == 'Email'">
                                        <input type="text" v-model="recip.target_value" placeholder="Enter an Email Address" class="form-control" />
                                    </template>

                                    <template v-if="recip.target_type == 'Role'">
                                        <b-form-select class="form-control" v-model="recip.target_value" :options="roleOptions" />
                                    </template>

                                    <span v-if="recip.target_type == 'User'" class="d-lg-inline-block" style="width: 400px;">
                                        <user-select
                                            :selectedValues="recip.target_label ? {UserId: recip.target_label.UserId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName} : null"
                                            @vuselected="function(user){ recip.target_value = user.UserId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false" />
                                    </span>

                                    <span v-if="errors['recipients['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['recipients['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>

                            <div v-if="errors.recipients" class="alert alert-danger">
                                <span v-for="(error, key) in errors.recipients"><template v-if="key > 0">, </template>{{ error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>

            <button type="button" class="btn btn-success" v-on:click="saveAlert()" :disabled="saving">
                <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                <template v-else>Save Email Alert</template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: this.$route.params.id,
                assetType: this.$route.query.asset_type,
                loading: true,
                saving: false,
                errors: {},
                alert: {},

                //Fields for Conditions
                fields: {},
                custom_fields: {},

                //Save Conditions
                conditions: [],
                custom_field_conditions: [],
                recipients: [],
                recipientTypes: [],
                titles: [],
                roles: [],
                yesNoTypes: [
                    'Dropdown',
                    'Checkbox',
                    'Radio',
                ]
            }
        },

        watch: {
            customFormId(newVal, oldVal){
                //If True, we need to load the custom forms
                if(newVal !== null && oldVal === null || newVal !== oldVal)
                {
                    //Fire it up
                    this.getCustomFormConditions();
                }
                else if (newVal === null)
                {
                    //Reset
                    this.custom_fields = {};
                    this.custom_field_conditions = [];
                }
            }
        },

        computed: {

            fieldOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Field --'}
                ];

                //Field Arrya
                var fieldArray = Object.values(this.fields);

                //Loop
                for(var i = 0; i < fieldArray.length; i++)
                {
                    //Push
                    options.push({value: fieldArray[i].id, text: fieldArray[i].field_label});
                }

                //Send it
                return options;
            },

            customFieldOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Custom Field --'}
                ];

                //Field Arrya
                var fieldArray = Object.values(this.custom_fields);

                //Loop
                for(var i = 0; i < fieldArray.length; i++)
                {
                    //Push
                    options.push({value: fieldArray[i].id, text: fieldArray[i].label});
                }

                //Send it
                return options;
            },

            recipientOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Target Type --'}
                ];

                //Loop
                for(var i = 0; i < this.recipientTypes.length; i++)
                {
                    //Push
                    options.push({value: this.recipientTypes[i], text: this.recipientTypes[i]});
                }

                //Send it
                return options;
            },

            roleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Role --'}
                ];

                //Loop
                for(var i = 0; i < this.roles.length; i++)
                {
                    //Push
                    options.push({value: this.roles[i].id, text: this.roles[i].name});
                }

                //Send it
                return options;
            },

            logicOptions(){
                //Send it
                return [
                    {value: null, text: '-- Select Logic --'},
                    {value: 'Equals', text: '='},
                    {value: 'Is Any', text: 'has any'},
                    {value: 'Is Not Any', text: 'none of'},
                    {value: 'Greater Than', text: '>'},
                    {value: 'Greater Or Equal', text: '>='},
                    {value: 'Less Than', text: '<'},
                    {value: 'Less Or Equal', text: '<='},
                ];
            },

            titleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Title --'}
                ];

                //Loop
                for(var i = 0; i < this.titles.length; i++)
                {
                    //Push
                    options.push({value: this.titles[i], text: this.titles[i]});
                }

                //Send it
                return options;
            },

            backRoute(){
                //Make sure it's set
                if(!this.assetType)
                {
                    return '';
                }

                //Setup
                var route = '/'+this.assetType.toLowerCase() + 's';

                //Handle it
                switch(this.assetType)
                {
                    case 'Observation':

                        break;

                    case 'CustomFormEntry':
                        //Setup
                        route = '/custom-forms#alerts';
                        break;

                    case 'SubPreQual':
                        //Setup
                        route = '/subcontractors/settings#alerts'
                        break;
                }

                //Send it
                return route;
            },

            backLabel(){
                //Setup
                var label = this.assetType + 's';

                //Handle it
                switch(this.assetType)
                {
                    case 'Observation':

                        break;

                    case 'CustomFormEntry':
                        //setup
                        label = 'Custom Forms';
                        break;

                    case 'SubPreQual':
                        //Setup
                        label = 'Subcontractor Settings';
                        break;
                }

                //Send it
                return label;
            },

            isCustomFormAlert(){
                //Check Asset Type
                if(this.assetType !== 'CustomFormEntry')
                {
                    return true;
                }

                //Default
                return false;
            },

            customFormId(){
                //Check Asset Type
                if(this.assetType !== 'CustomFormEntry')
                {
                    return null;
                }

                //Loop and Check All
                for (var i = this.conditions.length - 1; i >= 0; i--)
                {
                    //CHeck Condition LABEL, Logic, and Value
                    if(this.conditions[i].email_field_id === 8 && this.conditions[i].logic === 'Equals' && this.conditions[i].cond_value_formatted)
                    {
                        //Send it
                        return this.conditions[i].cond_value_formatted;
                    }
                }

                //Default
                return null;
            },
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('/email-alerts/edit' + (this.id ? '/' + this.id : ''), {asset_type: this.assetType})
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                        this.fields = res.data.fields;
                        this.custom_fields = res.data.custom_fields;
                        this.conditions = this.alert.conditions;
                        this.custom_field_conditions = res.data.custom_field_conditions;
                        this.recipients = this.alert.recipients;
                        this.recipientTypes = res.data.recipientTypes;
                        this.roles = res.data.roles;
                        this.titles = res.data.titles;
                        this.assetType = res.data.alert.asset_type;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            getCustomFormConditions(){
                //Send it
                this.$http.get('/custom-forms/filters', {covid_form_id: this.customFormId})
                    .then(response => {
                        //Setup Fields
                        var fields = response.data.filters;
                        var custom_fields = {};

                        //We need to build out the fields for the appropriate formatk
                        for (var i = fields.length - 1; i >= 0; i--)
                        {
                            //Append to the Object
                            custom_fields[fields[i].id] = fields[i];

                            //Setup ID
                            //custom_fields[fields[i].id].custom_field_id = fields[i].id;
                        }

                        //Set it
                        this.custom_fields = custom_fields;
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Load Custom Form Conditions');
                    })
                    .then(response => {
                        //Do something?
                    });
            },

            deleteCondition(key){
                //Splice
                this.conditions.splice(key, 1);
            },

            deleteRecipient(id){
                //Loop
                for (var i = 0; i < this.recipients.length; i++)
                {
                    //Check id
                    if(this.recipients[i].id == id)
                    {
                        this.recipients.splice(i, 1);
                    }
                }

                //For update
                this.$forceUpdate();

                //Splice
                //this.recipients.splice(key, 1);
            },

            customFieldLogic(custom_field_id){
                //Setup
                var field = null;

                //Setup
                var keys = Object.keys(this.custom_fields);

                //Get the field
                for (var i = 0; i < keys.length; i++)
                {
                    //Check it
                    if(this.custom_fields[keys[i]].id == custom_field_id)
                    {
                        field = this.custom_fields[keys[i]];
                    }
                }

                //Setup
                var options = [
                    {value: null, text: '-- Select Logic --'},
                ];

                //Check null
                if(field == null)
                {
                    //Send it
                    return options;
                }

                //Switch on the Field Type
                switch(field.type)
                {
                    case 'Checkbox':
                    case 'Radio':
                    case 'Dropdown':
                        //Append Options
                        options = [
                            {value: null, text: '-- Select Logic --'},
                            {value: 'equals', text: '='},
                        ];
                        break;

                    case 'Date':
                        //Append Options
                        options = [
                            {value: null, text: '-- Select Logic --'},
                            {value: 'days_before', text: 'Is X Days Before Date Value'},
                            {value: 'days_after', text: 'Is X Days After Date Value'},
                            {value: 'days_equal', text: 'Is = Date Value'},
                        ];
                        break;
                }

                //Send it
                return options;
            },

            //This is used for the CUSTOM FORMS
            customFieldValueOptions(custom_field_id){
                //Setup
                var field = null;

                //Setup
                var keys = Object.keys(this.custom_fields);

                //Get the field
                for (var i = 0; i < keys.length; i++)
                {
                    //Check it
                    if(this.custom_fields[keys[i]].id == custom_field_id)
                    {
                        field = this.custom_fields[keys[i]];
                    }
                }

                //Check null
                if(field == null)
                {
                    //Send it
                    return [
                        {value: null, text: '-- No Field Options Found --'},
                    ];
                }

                //Setup
                var options = [
                    {value: null, text: '-- Select Option for '+field.label+' --'},
                ];

                //SEtup Field Options
                //I HAVE NO IDEA WHY, but sometimes this is an array, other times, an object
                //var fieldOptions = Array.isArray(field.options) ? field.options : Object.values(field.options);
                var keys = Object.keys(field.options);

                //Loop and Build
                for (var i = 0; i < keys.length; i++)
                {
                    //Append
                    options.push({value: keys[i], text: field.options[keys[i]]});
                }

                //Send it
                return options;
            },

            deleteCustomFieldCondition(key){
                //Splice
                this.custom_field_conditions.splice(key, 1);
            },

            renderEmployee(recip){
                //Check for null
                if(!recip.target_label)
                {
                    return null;
                }

                //Send it
                return {
                    EmployeeId: recip.target_label.EmployeeId,
                    FirstName: recip.target_label.FirstName,
                    LastName: recip.target_label.LastName,
                    EmployeeNumber: recip.target_label.EmployeeNumber
                };
            },

            saveAlert(){
                //Saving Flag
                this.saving = true;
                this.errors = {};

                //Set the values
                this.alert.conditions = this.conditions;
                this.alert.recipients = this.recipients;
                this.alert.custom_field_conditions = this.custom_field_conditions;

                //Fix the conditions
                for(var i = 0; i < this.alert.conditions.length; i++)
                {
                    //Check it
                    if(this.alert.conditions[i].cond_value_formatted)
                    {
                        this.alert.conditions[i].cond_value = this.alert.conditions[i].cond_value_formatted;
                    }
                }

                //Send it
                this.$http.post('/email-alerts/edit', this.alert)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Email Alert Saved');

                        //Send to the View
                        this.$router.push(this.backRoute);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Save Alert');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            }
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
